function parseFilenameFromContentDisposition(contentDisposition) {
    if (!contentDisposition) return null;
    
    const filenameMatch = contentDisposition.match(/filename="(.+?)"/);
    const utf8FilenameMatch = contentDisposition.match(/filename\*\=UTF-8''(.+?)($|;)/);

    if (utf8FilenameMatch) {
        return decodeURIComponent(utf8FilenameMatch[1]);
    } else if (filenameMatch) {
        return filenameMatch[1];
    }

    return null;
}
